export interface ServiceItem {
  id: number;
  title: string;
  description: string;
  icon: string;
  shapeImg: string;
}

const service_data: ServiceItem[] = [
  {
    id: 1,
    title: "وسائل النقل",
    description:
      "نستورد أفضل أنواع وسائل النقل من جميع أنحاء العالم بجودة عالية.",
    icon: "/assets/icons/transport.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 2,
    title: "الزيوت",
    description:
      "أجود أنواع الزيوت الصناعية وزيوت السيارات من أفضل المصانع.",
    icon: "/assets/icons/oil.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 3,
    title: "الإطارات",
    description:
      "أفضل أنواع الإطارات من أشهر العلامات التجارية العالمية.",
    icon: "/assets/icons/tire.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 4,
    title: "البطاريات",
    description:
      "بطاريات عالية الجودة للسيارات والشاحنات بمواصفات عالمية.",
    icon: "/assets/icons/battery.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 5,
    title: "قطع الغيار",
    description:
      "جميع قطع الغيار الأصلية والبديلة بأسعار مناسبة وجودة مضمونة.",
    icon: "/assets/icons/spare-parts.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 6,
    title: "ملحقات السيارات",
    description:
      "جميع ملحقات السيارات والإكسسوارات اللازمة من مصادر موثوقة.",
    icon: "/assets/icons/car-parts.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 7,
    title: "خدمات الصيانة",
    description:
      "خدمات الصيانة والدعم الفني لجميع منتجاتنا مع ضمان الجودة.",
    icon: "/assets/icons/maintenance.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
  {
    id: 8,
    title: "خدمات التوزيع",
    description:
      "شبكة توزيع واسعة تغطي جميع المناطق مع ضمان وصول المنتجات في الوقت المحدد.",
    icon: "/assets/icons/distribution.svg",
    shapeImg: "/assets/img/core-img/shape7.png",
  },
];

export default service_data;